module.exports = __webpack_public_path__ + "static/media/tic-tac-toe.7b1eb1d3.jpg";